<template>
<div class="inspectionRecord1">
       <div class="orderBox" v-show="!exportSate" style="height:100%;">
       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="height:100%;">
		 <div style="width:100%; height:calc(100% - 50px);margin-bottom:10px;overflow:auto;">
         <el-form-item v-for="item in itemList" :key="item.id" :prop='item.props' :class="{labelSpe: item.type == 'upload' || item.type == 'SignCanvas' || item.title == '整改情况:'}">
            <div class="ItemCotentBox"  v-if="item.show">
             <div class="ItemText ItemCotentBoxlabel" >
               <label class="itemlabel">{{item.title}}</label>
            </div>
            <!-- input -->
             <div class="ItemCotent ItemCotent1">
                <div class="ItemCotent2" v-if="item.type=='input'">
                  <el-input v-model="ruleForm[item.props]"
                   :disabled="item.disabled || isShow"
                   :placeholder="item.placeholder" 
                   :type="item.InputType"
                   class="ItemCotent2"
                 />
                </div>
                 <!-- select -->
                <div class="ItemCotent2" v-else-if="item.type=='select' ">
                 <el-select v-model="ruleForm[item.props]"
                   :disabled="item.disabled" 
                   :placeholder="item.placeholder" 
                   class="ItemCotent2">
                   <el-option
                     v-for="item1 in item.options"
                     :key="item1.value"
                     :label="item1.label"
                     :value="item1.value">
                   </el-option>
                 </el-select>
                </div>
                <!-- datetime -->
                 <div class="ItemCotent2" v-else-if="item.type=='datetime' ">
                 <!-- <el-date-picker
                  class="ItemCotent2"
                  v-model="ruleForm[item.props]"
                  :type="item.type"
                  :placeholder="item.placeholder"
                  :default-time="item.defaulttime"
                  :value-format="item.format"
                  :disabled="item.disabled || isShow"
                  >
                  </el-date-picker> -->
                  <vDataPicker 
					v-if='item.id == 3'
					@changeValue="changeValueOne" 
					:item="item" 
					:disabled="item.disabled"
					:key="timekey"
					style="width:95%"
					:defaultValue="ruleForm[item.props]"/>
				  <vDataPicker 
					v-if='item.id == 4'
					@changeValue="changeValueTwo" 
					:item="item" 
					:disabled="item.disabled"
					:key="timekey"
					style="width:95%"
					:defaultValue="ruleForm[item.props]"/>
                </div>
                <!-- searchTree -->
                 <div class="ItemCotent2" v-else-if="item.type=='searchTree' ">
                    <div class="ItemCotent2">
                     <cPerson @changeValue="changeValue" :disabled="item.disabled" :defaultValue="ruleForm[item.props]"/>
                    </div>
                </div>
                <!-- upload -->
                <div class="ItemCotent2" v-else-if="item.type=='upload'  ">
                    <div class="ItemCotent2">
                     <cUpload ref="cUploads"
                     class="ItemCotent2"
                     v-if="!disabledState" 
                     :preview="true" 
                     @uploadFiles="uploadFiles" 
                     uploadType="inspectionRecord" 
                     :uploadParentId="ruleForm[item.props]" 
                     acceptFileType="jpg,jpeg,png,gif" 
                     :limitNum="5" limitSize="10M"/>
                     <cPhotoWall v-else :photoList="photoList" />
                    </div>
                </div>
                <!-- SignCanvas -->
                 <div class="ItemCotent2" v-else-if="item.type=='SignCanvas'  ">
                    <div class="ItemCotent2">
						<img v-show="ruleForm[item.props]" style='width:100%;height:auto;'
						:src="ruleForm[item.props]" alt='暂无图片'>
						<el-button type="primary" v-show="!ruleForm[item.props]" :disabled="item.disabled" @click="reformUserQZButton(item)">{{item.label}}</el-button>
                    </div>
                </div>
             </div>
            </div>
         </el-form-item>
		 </div>
         <div class="button" style="width:100%;">
			 <el-button type="primary" class='orderBtn' v-show="addinstate && stateCode0 && !isShow" @click="submitForm('ruleForm',1)">保存</el-button>
       <el-button type="primary" class='orderBtn' v-show="addinstate && stateCode1 && !isShow" @click="submitForm('ruleForm',2)">发送</el-button>
			 <el-button type="primary" class='orderBtnSpe' v-show="stateCode2 && !isShow" @click="submitForm('ruleForm',3)">整改完成</el-button> 
			 <el-button type="primary" class='orderBtnSpe' v-show="stateCode3 && !isShow" @click="submitForm('ruleForm',4)">验收确认</el-button>
         </div>
       </el-form>
       <el-button class="button" type="primary" @click="exportItem" v-show="stateCode4" style="position:fixed;bottom:20px;left: calc((100% - 40px )/2);">预览</el-button>
       </div>
       <order2 v-show="exportSate" :wordData="wordData"/>
       <el-dialog title="整改人签字" width="100%" :append-to-body="true" :visible.sync="rateState1">
         <cSignCanvas 
            :companySign="false" 
            :disabled="stateCanvas1 || isShow"
            :previewId="ruleForm.reformUserQZ" 
            @clearwrite="clearwrite" 
            @addSignBase64="addSignBase64"
            :width="600"
          />
       </el-dialog>
        <el-dialog title="验收人签字" width="100%" :append-to-body="true" :visible.sync="rateState2">
         <cSignCanvas 
            :companySign="false" 
            :disabled="stateCanvas2 || isShow"
            :previewId="ruleForm.checkUserQZ" 
            @clearwrite="clearwrite" 
            @addSignBase64="addSignBase64"
            :width="600"
          />
       </el-dialog>
</div>
</template>
<script>
  import cSignCanvas from '../element/c-signCanvas'
  import cPerson from "../element/c-personnel"
  import cUpload from '../element/c-upload'
  import cPhotoWall from '../element/c-photoWall'
  import order2 from './order2'
  import axios from 'axios'
  import vDataPicker from "../vant/v-data-picker"
  export default {
    name: 'order',
    props: {
      rowItem: Object,
      isShow: {
        type: Boolean,
        default: false
      },
	  addinstate:{
		  type: Boolean,
		  default: false
	  }
    },

    data () {
      return {
        exportSate:false,
        rateState1:false,//整改人签字弹窗状态
        rateState2:false,//验收人签字弹窗状态
		timekey:0,
        wordData:{},
        ruleForm: {
          id:'',
          status:"1",//督办状态
          businessId:"",//业务id
          qyId:"",//单位id
          qyName:"",//单位名称
          companyId:"",//专业化公司id
          companyName:"",//专业化公司名字
          superviseDesr:"",//督办事项
          superviseType:"",//事项类型
          superviseInfluence:"",//重大事项内容及影响程度
          superviseStandard:"",//处置要求与验收标准

          superviseUser:"",//督办人id
          superviseUserName:"",//督办人name
          telphoneNum:"",//手机号
          email:"",//电子邮箱
          fax:"",//传真
          superviseTime:"",//督办时间
          reformUser:"",//整改负责人
          reformTime:"",//整改最晚时间
          reformDesr:"",//整改情况
          reformImg:"",//整改图片
          reformUserQZ:"",//整改人签字
          reformUserQZSJ:"",//整改人签字时间
          checkUserQZ:"",//验收人签字
          checkUserQZSJ:"",//验收人签字时间
        },
        rules: {
          superviseUserName: [
            { required: true, message: '请选择督办人', trigger: 'blur' }
          ],
          superviseTime: [
            { required: true, message: '请选择督办时间', trigger: 'blur' }
          ],
          reformUser: [
            { required: true, message: '请选择整改负责人', trigger: 'blur' }
          ],
          reformTime: [
            { required: true, message: '请选择整改最晚时间', trigger: 'blur' }
          ],
          reformUserName: [
            { required: true, message: '请选择整改人', trigger: 'blur' }
          ],
          superviseDesr: [
            { required: true, message: '请输入督办事项', trigger: 'blur' }
          ],
          // reformDesr: [
          //   { required: true, message: '请输入整改情况', trigger: 'blur' }
          // ],
          // reformUserQZ:[
          //   { required: true, message: '请签字', trigger: 'blur' }
          // ],
          // reformUserQZ:[
          //   { required: true, message: '请签字', trigger: 'blur' }
          // ],
          superviseType:[
            { required: true, message: '请输入选择事项类型', trigger: 'blur' }
          ],
          superviseInfluence:[
            { required: true, message: '请输入重大事项内容及影响程度', trigger: 'blur' }
          ],//重大事项内容及影响程度
          superviseStandard:[
            { required: true, message: '请输入处置要求与验收标准', trigger: 'blur' }
          ],//处置要求与验收标准
        },
        superviseDesrList:[
          {
            value:"粉尘爆炸",
            label:"粉尘爆炸"
          },
          {
            value:"受限空间",
            label:"受限空间"
          },
          {
            value:"火灾消防",
            label:"火灾消防"
          },
          {
            value:"特种设备",
            label:"特种设备"
          },
        ],
        superviseTypeList:[
           {
            value:"事故整改",
            label:"事故整改"
          },
          {
            value:"重大隐患",
            label:"重大隐患"
          },
          {
            value:"超标违规",
            label:"超标违规"
          },
          {
            value:"工作指令",
            label:"工作指令"
          },
        ],
        disabledState:false,
        stateCanvas1:false,
        stateCanvas2:false,
        orderCode:false,
        state0:true,
        state1:false,
        state2:false,
        statedis0:false,
        statedis1:false,
        stateCode0:false,
        stateCode1:false,
        stateCode2:false,
        stateCode3:false,
        stateCode4:false,
		hmz:false,
        Username:"",
        qyName:"",
        companyName:"",
        photoList:[],
        disabled1:false,
        disabled2:false,
        itemList:[
          //companyName
          {
            id:0,
            title:"专业化公司:",
            type:"input",
            InputType:"",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"companyName",
            className:"",
            placeholder:""
          },
          //qyName
          {
            id:1,
            title:"单位名称:",
            type:"input",
            InputType:"",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"qyName",
            className:"",
            placeholder:"",
          },
          //superviseTyp
           {
            id:2,
            title:"事项类型:",
            type:"select",
             disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"superviseType",
            className:"",
            placeholder:"请选择事项类型",
            options:[
              {
              value:"事故整改",
              label:"事故整改"
             },
             {
               value:"重大隐患",
               label:"重大隐患"
             },
             {
               value:"超标违规",
               label:"超标违规"
             },
             {
               value:"工作指令",
               label:"工作指令"
             },
            ]
          },
          //superviseTime
          {
            id:3,
            title:"督办时间:",
            titleName:"请选择督办时间",
            type:"datetime",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"superviseTime",
            className:"",
            placeholder:"请选择督办时间",
            defaulttime:'12:00:00',
            format:"yyyy-MM-dd HH:mm",
          },
          //reformTime
          {
            id:4,
            title:"整改时限:",
            titleName:"请选择整改时限",
            type:"datetime",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"reformTime",
            className:"",
            placeholder:"请选择整改时限",
            defaulttime:'12:00:00',
            format:"yyyy-MM-dd HH:mm",
          },
          //superviseUserName
          {
            id:5,
            title:"督办人:",
            type:"input",
            InputType:"",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"superviseUserName",
            className:"",
            placeholder:""
          },
          //telphoneNum
          {
            id:6,
            title:"手机号:",
            type:"input",
            InputType:"",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"telphoneNum",
            className:"",
            placeholder:""
          },
          //fax
          //  {
          //   id:7,
          //   title:"传真:",
          //   type:"input",
          //   disabled:true,//是否禁用
          //   show:true,//显示隐藏
          //   InputType:"",
          //   props:"fax",
          //   className:"",
          //   placeholder:"请填写传真"
          // },
          //email
           {
            id:8,
            title:"邮箱:",
            type:"input",
            InputType:"",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"email",
            className:"",
            placeholder:"请填写邮箱"
          },
          //reformUser
          {
            id:9,
            title:"整改负责人:",
            type:"searchTree",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"reformUser",
            className:"",
            placeholder:"请选择整改负责人"
          },
          // superviseDesr
          {
            id:10,
            title:"事项名称:",
            type:"input",
            InputType:"textarea",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"superviseDesr",
            className:"",
            placeholder:"请输入事项名称"
          },
          // superviseInfluence
           {
            id:11,
            title:"影响程度:",
            type:"input",
            InputType:"textarea",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"superviseInfluence",
            className:"",
            placeholder:"影响程度"
          },
          //superviseStandard
           {
            id:12,
            title:"验收标准:",
            type:"input",
            InputType:"textarea",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"superviseStandard",
            className:"",
            placeholder:"验收标准"
          },
          //reformDesr
          {
            id:13,
            title:"整改情况:",
            type:"input",
            InputType:"textarea",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"reformDesr",
            className:"",
            placeholder:"请输入整改情况"
          },
          //upload  id
           {
            id:14,
            title:"图片上传:",
            type:"upload",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"id",
            className:"",
          },
          //SignCanvas reformUserQZ
           {
            id:15,
            title:"整改人签字:",
            label:"整改人签字",
            type:"SignCanvas",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"reformUserQZ",
            className:"",
            width:200
          },
          //reformUserQZSJ
           {
            id:16,
            title:"签字时间:",
            type:"input",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"reformUserQZSJ",
            className:"",
            width:200
          },
          // checkUserQZ
           {
            id:17,
            title:"验收人签字:",
            label:"验收人签字",
            type:"SignCanvas",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"checkUserQZ",
            className:"",
            width:200
          },
          // checkUserQZSJ
           {
            id:18,
            title:"验收时间:",
            type:"input",
            disabled:true,//是否禁用
            show:true,//显示隐藏
            props:"checkUserQZSJ",
            className:"",
            width:200
          },
        ]
      }
    },

    components: {
      cSignCanvas,
      cPerson,
      cPhotoWall,
      cUpload,
      order2,
      vDataPicker
    },

    created() {
		if(sessionStorage.getItem("GCMZ")){
			this.hmz = true;
		}else{
			sessionStorage.setItem("GCMZ",this.rowItem.qyName);
			this.hmz = false;
		}
		
    },
	beforeDestroy() {
		if(!this.hmz){
			sessionStorage.removeItem("GCMZ")
		}
	},
    mounted() {
    this.getOne()
    },

    methods: {
      reformUserQZButton(item){
        let id=item.props;
        switch(id){
          case 'checkUserQZ':
          this.rateState1=false;
          this.rateState2=true;
          break;
          case 'reformUserQZ':
          this.rateState1=true;
          this.rateState2=false;
          break;
        }
      },
      submitForm(formName,code) {
        let that = this
        if(code == 3){
          if(!that.ruleForm.reformDesr){
            this.$message({
								 type:'error',
								 message:"请填写整改情况"
							 })
						return false
          }
					let fileArr = that.$refs.cUploads[0].$refs.cUpload.uploadFiles
					if(fileArr.length == 0){
						this.$message({
							type: 'error',
							message:"请上传图片",
						})
						return false;
					}
					if(!that.ruleForm.reformUserQZ){
						this.$message({
								 type:'error',
								 message:"整改人未签字"
							 })
						return false
					}
				}
				if(code == 4){
					if(!that.ruleForm.checkUserQZ){
						this.$message({
								 type:'error',
								 message:"验收人未签字"
							 })
						return false
					}
				}
        this.$refs[formName].validate((valid)=>{
          if (valid) {
            switch(code){
              case 1:
                this.save();
              break;
              case 2:
                this.commit(2);
              break;
              case 3:
			  this.ruleForm.imgbaseurl = sessionStorage.getItem("baseURL");
                this.commit(3);
              break;
              case 4:
                this.commit(4);
              break;
            }
          } else {
            return false;
          }
        });
      },
	  getUserInfoById:function(value){
	  	var id = value;
	  	this.$axios.get('/user/userAdmin/' + id, {}).then((data) => {
	  		let user = data.data.data;
	  		if(user){
	  			this.ruleForm.telphoneNum = user.phoneNum;
	  			this.ruleForm.email = user.email;
	  		}
	  	})
	  },
      getOne(){
        let _that = this
		this.state1=false;
		this.disabled1=false;
		this.disabled2=false;
		this.stateCode0=false;
		this.stateCode1=false;
		this.stateCode2=false;
		this.stateCode3=false;
		this.stateCode4=false
		this.exportSate=false;
        let obj={}
         obj.businessId=this.rowItem.id;
         this.$axios.post('/dform/supervise/getOne', obj)
        .then((res) => {
          if(res.data.code){
             if(res.data.data==null){
               //获取初始化信息
                this.ruleForm.id=this.common.uuid();//生成id
                this.ruleForm.businessId=this.rowItem.id;
                let obj=sessionStorage.getItem('loginUser')
                obj=JSON.parse(obj)
                this.qyName = this.rowItem.qyname;
                this.companyName = this.rowItem.companyName
                this.ruleForm.companyId = this.rowItem.companyId;
                this.ruleForm.companyName = this.rowItem.companyName
                this.ruleForm.qyId =  this.rowItem.qyId;
                this.ruleForm.qyName =  this.rowItem.qyName;
                let loginUser=sessionStorage.getItem('loginUser');
                loginUser=JSON.parse(loginUser);
                this.ruleForm.telphoneNum=loginUser.phoneNum;
                this.Username=loginUser.loginName;
                this.ruleForm.superviseUser=loginUser.userId;
                this.ruleForm.superviseUserName=loginUser.loginName;
				this.getUserInfoById(loginUser.userId);
                //表单项显示隐藏、禁用
                this.itemList.map((item,index)=>{
                  if(index<12){
                    item.show=true;
                    if(index==0 || index==1 ||index==5 ||index==6){
                      item.disabled=true;
                    }else{
                      item.disabled=false;
                    }
                  }else{
                    item.show=false;
                  }
                })
				this.timekey++;
                this.state1=false;
                this.disabled1=false;
                this.disabled2=false;
                this.stateCode0=true;
                this.stateCode1=true;
                this.stateCode2=false;
                this.stateCode3=false;
                this.stateCode4=false
                this.exportSate=false;
             }else{

               this.Username=res.data.data.superviseUserName;
               this.qyName=res.data.data.qyName;
               this.companyName=res.data.data.companyName
               for(let key in this.ruleForm){
                 this.ruleForm[key]=res.data.data[key];
               }
              if(!this.ruleForm.reformUserQZ){
                this.ruleForm.reformUserQZ = "";
              }
              if(!this.ruleForm.checkUserQZ){
                this.ruleForm.checkUserQZ = "";
              }
               this.exportSate=false;
               this.wordData=res.data.data;
               let loginUserid1=sessionStorage.getItem('userId')
               let reformUserObj = ''
               let userid1 = ''
               if(res.data.data.reformUser){
                  reformUserObj=JSON.parse(res.data.data.reformUser)
                  userid1=reformUserObj[0].userid
               }
               if(res.data.data.status=='1'){
                 //督办人
                  if(loginUserid1==res.data.data.superviseUser){
                     //表单项显示隐藏、禁用
                     this.itemList.map((item,index)=>{
                       if(index<12){
                          if(index==0 || index==1 ||index==5 ||index==6){
                            item.disabled=true;
                          }else{
                            item.disabled=false;
                          }
                       }else{
                         item.show=false;
                       }
                     })
                    _that.state1=false;
                    _that.stateCode0=true;
                    _that.stateCode1=true;
                    _that.stateCode2=false;
                    _that.stateCode3=false;
                    _that.stateCode4=false
                  }
                  //整改人
                  // if(loginUserid1 == userid1){
                  //    //表单项显示隐藏、禁用
                  //     this.itemList.map((item,index)=>{
                  //       item.show=false;
                  //     })
                  //   this.state1=true;
                  //   this.stateCode0=false;
                  //   this.stateCode1=false;
                  //   this.stateCode2=false;
                  //   this.stateCode3=false;
                  //   this.stateCode4=false
                  // }
               }
               if(res.data.data.status=='2'){
                  // if(loginUserid1==res.data.data.superviseUser){
                  //   this.itemList.map((item,index)=>{
                  //      if(index<13){
                  //         item.show=true
                  //         item.disabled=true;//发送之前后全部禁用
                  //      }else{
                  //        item.show=false;
                  //      }
                  //    })
                  //   this.statedis0=true;
                  //   this.state1=false;
                  //   this.disabled1=true;
                  //   this.disabled2=false;
                  //   this.stateCode0=false;
                  //   this.stateCode1=false;
                  //   this.stateCode2=false;
                  //   this.stateCode3=false;
                  //   this.stateCode4=false
                  // }
                  if(loginUserid1==userid1){
                    this.itemList.map((item,index)=>{
                        item.show=true;
                        if(index<12){
                           item.disabled=true;
                        }else{
                           if(index>=15){
                            item.disabled=true;
                           }else{
                             item.disabled=false;
                           }
                        }
                      })
                    this.state1=true;
                    this.disabled1=true;
                    this.disabled2=false;
                    this.stateCanvas1=false;
                    this.stateCanvas2=true;
                    this.stateCode0=false;
                    this.stateCode1=false;
                    this.stateCode2=true;
                    this.stateCode3=false;
                    this.stateCode4=false
                  }
               }
               if(res.data.data.status=='3'){
                  if(loginUserid1==res.data.data.superviseUser){
                     this.itemList.map((item,index)=>{
                        item.show=true;
                        if(index<13){
                           item.disabled=true;
                        }else{
                           if(index==16){
                            item.disabled=false;
                           }else{
                            item.disabled=true;
                           }
                        }
                      })
                    this.state1=true;
                    this.disabled1=true;
                    this.disabled2=true;
                    this.stateCanvas1=true;
                    this.stateCanvas2=false;
                    this.stateCode0=false;
                    this.stateCode1=false;
                    this.stateCode2=false;
                    this.stateCode3=true;
                    this.stateCode4=false
                  }
                  // if(loginUserid1==userid1){
                  //   this.itemList.map((item,index)=>{
                  //       item.show=true;
                  //       item.disabled=true;
                  //     })//全部显示、全部禁用
                  //   this.state1=true;
                  //   this.disabled1=true;
                  //   this.disabled2=true;
                  //   this.stateCanvas1=false;
                  //   this.stateCanvas2=true;
                  //   this.stateCode0=false;
                  //   this.stateCode1=false;
                  //   this.stateCode2=false;
                  //   this.stateCode3=false;
                  //   this.stateCode4=false
                  // }
               }
                if(res.data.data.status=='4' || res.data.data.status=='5'){
                    this.itemList.map((item,index)=>{
                        item.show=true;
                        item.disabled=true;
                      })//全部显示、全部禁用
                    this.state1=true;
                    this.disabled1=true;
                    this.disabled2=true;
                    this.stateCanvas1=true;
                    this.stateCanvas2=true;
                    this.stateCode0=false;
                    this.stateCode1=false;
                    this.stateCode2=false;
                    this.stateCode3=false;
                    this.stateCode4=true;
               }
             }
          }
         
         })
      },
      save(){
        let _that=this;
        this.$axios.post('/dform/supervise/saveWorkPolling',this.ruleForm)
        .then((res) => {
          if(res.data.code){
            _that.$message({
							type: 'success',
							message:"成功",
            })
            this.getOne();
            // this.$emit('orderOpen','close')
          }
         
        })
      },
      uploadFiles(params){
      },
      changeValue(value){
            this.ruleForm.reformUser=JSON.stringify(value.value);
      },
      changeValueOne(value){
        this.ruleForm.superviseTime=value.value
      },
      changeValueTwo(value){
        this.ruleForm.reformTime=value.value
      },
			async addSignBase64(base64){
				let _that = this
				let year,month,date,hours,minutes,second;
				let value=new Date();
				year=value.getFullYear();
				month=value.getMonth()+1;
				date=value.getDate();
				if(date<10) date='0'+date
				hours=value.getHours()
				if(hours<10) hours='0'+hours
				minutes=value.getMinutes()
				if(minutes<10)minutes='0'+minutes
				second=value.getSeconds()
				if(second<10)second='0'+second
				let selectTime=year+'-'+month+'-'+date+' '+hours+':'+minutes
				if(this.stateCanvas1){
				  _that.ruleForm.checkUserQZ =base64
				  _that.ruleForm.checkUserQZSJ =selectTime
				}
				if(this.stateCanvas2){
				   _that.ruleForm.reformUserQZ =base64
				  _that.ruleForm.reformUserQZSJ=selectTime
				}
				 _that.rateState1=false;
				 _that.rateState2=false;
				 
				let url = ''
				//////
				/* await axios({
					method:'post',//请求类型
					url: '/mongodb/uploadFile',//,//请求地址,端口号
					data: formdata, //request body
				}).then((res) => {
					if(res.data.code === 1){
						_that.$message({
							type: 'success',
							message:"文件上传成功",
						})
					}
				}).catch((err) => {
					_that.$message({
						type: 'error',
						message:err,
					})
				}) */
      },
      uploadFiles(params){
      },
      clearwrite(params){
        // this.orderObj.reformUserQZ = params
        // this.orderObj.checkUserQZ = params
      },
      async commit(st){
        let _that=this;
		if(st == 3){
			let fileArr = _that.$refs.cUploads[0].$refs.cUpload.uploadFiles
			if(fileArr.length == 0){
			  
			}else{
				await _that.$refs.cUploads[0].$refs.cUpload.submit()
			}
		}
        this.$axios.post('/dform/supervise/commitSupervise',this.ruleForm)
        .then((res) => {
          if(res.data.code){
            _that.$message({
				type: 'success',
				message:"成功",
            })
            this.getOne();
          }
         this.$emit('orderOpen','close')
        })
      },
      exportItem(){
          this.exportSate=true;
      },
    },

    computed: {
      
    },
    destroyed(){
    },
    watch: {
      rowItem(val,oldVal){
        if(val!==""){
          this.getOne()
        }
      },
    },

  }
</script>

<style  scoped>
.inspectionRecord1{
  height: 100%;
  padding-top: 1.5rem;
  overflow: auto;
}
.inspectionRecord1 >>> .el-form-item.is-required .itemlabel:before,
	.inspectionRecord1 >>> .el-form-item.labelSpe .itemlabel:before{
		content: "*";
		color: #f56c6c;
		margin-right: 4px;
	}
.inspectionRecord1 .orderBtn{
  width:50%;
  font-size:.4rem;
}
.inspectionRecord1 .orderBtnSpe{
  width:100%;
  font-size:.4rem;
  margin-left:0;
  border-radius:0;
  border-color:#ccc;
}
.inspectionRecordBody1 .el-form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap; 
}
.problemCheckIssue{
  /* margin-right: 200px; */
}
.inspectionRecordBody1 .el-form-item {
   width:100%;
}
.inspectionRecordBody1 .el-form-item .el-form-item__label{
  width: 40%;
}
.inspectionRecordBody1 .el-form-item__content{
  width: 65%;
  display: inline-block;
}
.recordCard .upImg img{
   height:40px;
  
}
.el-input{
  width:80%;
}
.recordCard .writeImg img{
  height:40px;
  
}
.button{
   display: flex;
   justify-content: center;
  /* position:fixed;
   bottom: 10px; */
   /* left:25%; */
   /* width: 1.1rem;
   height: 1.1rem; */
}
.el-button{
  /* margin:0% 1%; */
}

/* .personBox{
  width:380px;
} */
.itemlabel{
  font-size: 15px;
  font-weight:bold;
  color: #333;
}
.ItemText{
  text-align: right;
}
.ItemCotentBox{
  width:100%;
  display:flex;
}
.ItemCotentBoxlabel{
  width:26.7%;
}
.ItemCotent{
  width:73.3%;
}
.ItemCotent1{
  display:flex;
  align-items:center;
}
.ItemCotent2{
  /* height:100%; */
   width:95%;
}
</style>
